import { useEffect } from 'react';
export const COOKIE_CONSENT_SET_SHOW_SETTINGS_EVENT_NAME = 'hn-cookie-consent-show-modal';
/**
 * Vis cookie-banner
 */
export const HNeventShowCookieBanner = (onChange) => {
    document.dispatchEvent(new CustomEvent(COOKIE_CONSENT_SET_SHOW_SETTINGS_EVENT_NAME, { detail: { show: true, onChange } }));
};
/**
 * Lytt på endringer i visning av cookie-banner
 */
export const useSetShowCookieSettings = (onHandle) => {
    useEffect(() => {
        const handleShowCookieSettingsEvent = (event) => {
            onHandle(event.detail);
        };
        document.addEventListener(COOKIE_CONSENT_SET_SHOW_SETTINGS_EVENT_NAME, handleShowCookieSettingsEvent);
        return () => {
            document.removeEventListener(COOKIE_CONSENT_SET_SHOW_SETTINGS_EVENT_NAME, handleShowCookieSettingsEvent);
        };
    }, [onHandle]);
};
export const COOKIE_CONSENT_CHANGE = 'hn-cookie-consent-change';
/**
 * Dispatch event om at cookie-samtykker har endret seg
 *
 * @param options Brukerens cookie-samtykker
 */
export const HNeventCookieConsentChange = (options) => {
    document.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGE, { detail: { options } }));
};
/**
 * Lytt på endringer i cookie-samtykker
 */
export const useCookieConsentChange = (onHandle) => {
    useEffect(() => {
        const handleCookieConsentOptionsChanged = (event) => {
            onHandle(event.detail);
        };
        document.addEventListener(COOKIE_CONSENT_CHANGE, handleCookieConsentOptionsChanged);
        return () => {
            document.removeEventListener(COOKIE_CONSENT_CHANGE, handleCookieConsentOptionsChanged);
        };
    }, [onHandle]);
};
